module.exports = __webpack_public_path__ + "static/media/notificationSound.15b0efd7.mp3";